import { Injectable } from '@angular/core';
import { ItemVariation } from '../models/item-variation.model';
import { SeFeServiceService } from 'se-fe-service';
import { SeFeApiService } from 'se-fe-api';

@Injectable({ providedIn: 'root' })
export class ItemVariationService extends SeFeServiceService<ItemVariation> {
  public Model: any = ItemVariation;
  protected endpoint = 'finance/item_variations';

  constructor(
    protected apiService: SeFeApiService
  ) {
    super(apiService);
  }
}
